var map = {
	"./i18n-default": 4848,
	"./i18n-default.json": 4848,
	"./i18n-ssk": 5584,
	"./i18n-ssk.bak": 3523,
	"./i18n-ssk.bak.json": 3523,
	"./i18n-ssk.json": 5584,
	"./i18n-wsf": 7395,
	"./i18n-wsf.json": 7395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;